import axios from 'axios';

// axios.defaults.baseURL = 'http://localhost:3014'; //local
// axios.defaults.baseURL = 'http://44.230.62.131:3014'; //development
// axios.defaults.baseURL = 'http://44.218.13.68:3013'; //live_demo
axios.defaults.baseURL = 'https://api.agtrack.co.nz/'; //live

axios.interceptors.request.use(
    async (config) => {
        const authUser = localStorage.getItem('ag-authUser');
        const user = JSON.parse(authUser);
        if (user) {
            const token = user.token;
            config.headers.accessToken = token;
            if ((config.url.includes('/api/users/updateProfile')) || (config.url.includes('/api/uploadSurveyData'))) {
                config.headers = { "Content-Type": "multipart/form-data", 'x-access-token': token };
            }
            else {
                config.headers = { "Content-Type": "application/json", 'x-access-token': token };
            }
        }
        else {
            config.headers = { "Content-Type": "application/json" };
        }
        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);
axios.interceptors.response.use(
    (response) => response,
    (error) => {
        const config = error.config || {};

        // If we already redirected once, skip
        if (config._redirectHandled) {
            return Promise.reject(error);
        }

        // Mark this error as handled
        config._redirectHandled = true;

        if (error.response) {
            const status = error.response.status;

            if (status === 401) {
                localStorage.clear();
                window.location.href = process.env.REACT_APP_BASE_URL; // Redirect to login page
            } 
        } else if (error.request) {
            // Server did not respond — network error
            console.error('Network error: No response from server');
        } else {
            // Something went wrong setting up the request
            console.error('Axios setup error:', error);
        }

        return Promise.reject(error);
    }
);